
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invalid-link",
      function () {
        return require("private-next-pages/invalid-link/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invalid-link"])
      });
    }
  